import React from 'react';
import icRefresh from 'assets/svg/ic_refresh_white_v2.svg';
import icRefreshDisabled from 'assets/svg/ic_refresh_disable_v2.svg';
import classNames from 'classnames';
import styles from './styles.module.scss';

const RefreshButton = ({
  onClick,
  className,
  limitCountTime
}) => {
  const timerRef = React.useRef();
  const [countDown, setCountDown] = React.useState(0);
  const [disabled, setDisabled] = React.useState(countDown > 0);
  React.useEffect(() => {
    setDisabled(countDown > 0);
  }, [countDown]);
  React.useEffect(() => {
    if (countDown <= 0 && timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, [countDown]);
  React.useEffect(() => {
    return () => {
      timerRef.current && clearInterval(timerRef.current);
    };
  }, []);

  const startCountDown = () => {
    setCountDown(limitCountTime);
    timerRef.current = setInterval(() => {
      setCountDown(pre => pre - 1);
    }, 1000);
  };

  const onPress = () => {
    if (disabled) return;
    startCountDown();
    onClick();
  };

  return /*#__PURE__*/React.createElement("div", {
    onClick: onPress,
    className: classNames(styles.container, disabled ? styles.disabled : undefined, className)
  }, /*#__PURE__*/React.createElement("img", {
    src: disabled ? icRefreshDisabled : icRefresh,
    className: classNames(styles.icon, disabled ? styles.disabled : undefined)
  }), /*#__PURE__*/React.createElement("span", null, disabled ? `Refresh in ${countDown}` : 'Refresh'));
};

export default RefreshButton;